'use client';

import { BlogTrialDrawerMobile } from './blog-trial-drawer-mobile';
import { BlogTrialBannerDesktop } from './blog-trial-banner-desktop';

interface BlogTrialPromotionProps {
  postSlug: string;
  isAuthenticated: boolean;
}

export function BlogTrialPromotion({ postSlug, isAuthenticated }: BlogTrialPromotionProps) {
  return (
    <>
      <BlogTrialDrawerMobile postSlug={postSlug} isAuthenticated={isAuthenticated} />
      <BlogTrialBannerDesktop postSlug={postSlug} isAuthenticated={isAuthenticated} />
    </>
  );
}
